module.exports = require("@workbench-stack/output-browser");